import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withStyles } from 'material-ui/styles';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import { formatDate } from '../../../../../../utils/date-utils';

const styles = theme => ({
  withoutLabel: {
    marginTop: theme.spacing.unit,
  },
  inputDisabled: {
    color: theme.palette.text.primary,
  }
});

const BaseInput = props => {
  const {
    classes,
    id,
    value,
    readonly,
    disabled,
    autofocus,
    onBlur,
    onFocus,
    options,
    schema,
    errorSchema,
    formContext,
    registry,
    label,
    onChange,
    ...inputProps
  } = props;
  inputProps.type = options.inputType || inputProps.type || 'text';
  const { format } = schema;
  const formatValue = value => {
    const val = value === undefined || value === null ? '' : value;
    switch (format) {
      case 'date':
        return formatDate(val);
      default:
        return val;
    }
  };

  const displayLabel = schema.title !== undefined;

  return (
    <FormControl
      disabled
      margin="normal"
      fullWidth
      className={classnames({
        [classes.withoutLabel]: !displayLabel,
      })}
    >
      {displayLabel && (
        <InputLabel htmlFor={id} shrink>
          {label}
        </InputLabel>
      )}
      <Input id={id} value={formatValue(value)} readOnly={readonly} classes={{inputDisabled:classes.inputDisabled}}/>
    </FormControl>
  );
};

BaseInput.defaultProps = {
  type: 'text',
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false,
  options: [],
};

BaseInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.object,
  schema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  registry: PropTypes.object.isRequired,
};

export default withStyles(styles)(BaseInput);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/readonly/BaseInput.js